import { IncomingMessage } from 'http';
import addDays from 'date-fns/addDays';
import { USER_COOKIE } from '../../@packages/common/constants/cookies';

import { createHash, biFriendlyCookieEncode, biFriendlyCookieDecode, CookieConfig } from '../cookieHelpers';

export function getUserCookieConfig(req: IncomingMessage): Record<string, CookieConfig> {
  if (!req.cookies) {
    return {
      userCookieConfig: {
        name: USER_COOKIE.name,
        value: '',
        options: {
          maxAge: -1,
        },
      },
      userOldCookieConfig: {
        name: USER_COOKIE.oldName,
        value: '',
        options: {
          maxAge: -1,
        },
      },
    };
  }

  const userCookie = req.cookies[USER_COOKIE.oldName]
    ? JSON.parse(req.cookies[USER_COOKIE.oldName])
    : biFriendlyCookieDecode(req.cookies[USER_COOKIE.name]) ?? {};

  const cookieIsValid =
    userCookie &&
    typeof userCookie.hash === 'string' &&
    typeof userCookie.created === 'string' &&
    typeof userCookie.modified === 'string';

  const now = new Date();
  const nowStr = now.toISOString();
  const updatedCookie = cookieIsValid
    ? { ...userCookie, modified: nowStr }
    : {
        hash: createHash(),
        created: nowStr,
        modified: nowStr,
      };

  const userCookieConfig: CookieConfig = {
    name: USER_COOKIE.name,
    value: JSON.stringify(updatedCookie),
    options: {
      httpOnly: false,
      path: '/',
      encode: biFriendlyCookieEncode(updatedCookie.hash),
      expires: addDays(now, USER_COOKIE.expires),
    },
  };

  const userOldCookieConfig: CookieConfig = {
    name: USER_COOKIE.oldName,
    value: '',
    options: {
      maxAge: -1,
      path: '/',
    },
  };

  return {
    userCookieConfig,
    userOldCookieConfig,
  };
}
